module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Live Class',
          to: {
            path: '/live-class'
          }
        },
        {
          text: 'Laporan Live Class'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n                    Laporan Live Class\n                ")])]), _vm._v(" "), _c('v-cols', {
    staticClass: "align-right",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "text-right mt-5"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 120,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('span', {
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v("\n                                Filter   ")]), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "depressed": "",
            "color": "white",
            "width": "120"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "blew--text"
        }, [(_vm.filter_type === 'ALL') ? _c('span', [_vm._v("Semua")]) : _vm._e(), _vm._v(" "), (_vm.filter_type === 'CUSTOM') ? _c('span', [_vm._v("Custom")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
          staticClass: "ml-6",
          attrs: {
            "color": "blew",
            "small": ""
          }
        }, [_vm._v("\n                                        mdi-chevron-down\n                                    ")])], 1)])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "pt-7",
    attrs: {
      "width": "350"
    }
  }, [_c('v-card-title', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                                            Rentang Tanggal\n                                        ")]), _vm._v(" "), _c('div', [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Rentang Tanggal",
      "items": [{
          text: 'Semua',
          value: 'ALL',
        },
        {
          text: 'Custom',
          value: 'CUSTOM',
        } ]
    },
    model: {
      value: (_vm.filter_type),
      callback: function($$v) {
        _vm.filter_type = $$v
      },
      expression: "filter_type"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.filter_type === 'CUSTOM') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                                                    Dari Tanggal\n                                                ")]), _vm._v(" "), _c('div', [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "return-value": _vm.date,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
            attrs: {
              "outlined": "",
              "dense": "",
              "readonly": ""
            },
            model: {
              value: (
                _vm.date
              ),
              callback: function($$v) {
                _vm.date
                  = $$v
              },
              expression: "\n                                                                    date\n                                                                "
            }
          }, 'v-text-field',
          attrs, false), on))]
      }
    }], null, false, 1103915710),
    model: {
      value: (_vm.modal_date),
      callback: function($$v) {
        _vm.modal_date = $$v
      },
      expression: "modal_date"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal_date = false
      }
    }
  }, [_vm._v("\n                                                                Cancel\n                                                            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog.save(
          _vm.date
        )
      }
    }
  }, [_vm._v("\n                                                                OK\n                                                            ")])], 1)], 1)], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                                                    Sampai Tanggal\n                                                ")]), _vm._v(" "), _c('div', [_c('v-dialog', {
    ref: "dialog2",
    attrs: {
      "return-value": _vm.date2,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date2 = $event
      },
      "update:return-value": function($event) {
        _vm.date2 = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
            attrs: {
              "outlined": "",
              "dense": "",
              "readonly": ""
            },
            model: {
              value: (
                _vm.date2
              ),
              callback: function($$v) {
                _vm.date2
                  = $$v
              },
              expression: "\n                                                                    date2\n                                                                "
            }
          }, 'v-text-field',
          attrs, false), on))]
      }
    }], null, false, 2166016140),
    model: {
      value: (
        _vm.modal_date2
      ),
      callback: function($$v) {
        _vm.modal_date2
          = $$v
      },
      expression: "\n                                                            modal_date2\n                                                        "
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.date2),
      callback: function($$v) {
        _vm.date2 = $$v
      },
      expression: "date2"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal_date2 = false
      }
    }
  }, [_vm._v("\n                                                                Cancel\n                                                            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog2.save(
          _vm.date2
        )
      }
    }
  }, [_vm._v("\n                                                                OK\n                                                            ")])], 1)], 1)], 1)])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-5 pr-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_vm._v("\n                                    Batal\n                                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doFilter()
      }
    }
  }, [_vm._v("\n                                    Terapkan\n                                ")])], 1)], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 mt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Total Semua Problem")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 black--text mt-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.total_problem) + "\n                            "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Laporan")])])])], 1)], 1), _vm._v(" "), _vm._l((_vm.problem), function(data, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "3"
      }
    }, [_c('v-card', {
      staticClass: "mt-5",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-5"
    }, [_c('div', {
      staticClass: "grey--text"
    }, [_vm._v("\n                            " + _vm._s(data.problem_name) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "font-weight-700 black--text mt-2",
      staticStyle: {
        "font-size": "24px"
      }
    }, [_vm._v("\n                            " + _vm._s(data.count) + "\n                            "), _c('span', {
      staticClass: "font-weight-400",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                Laporan\n                            ")])])])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Laporan Live Class ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.data,
      "headers": _vm.headers,
      "has-action": false,
      "has-export": true,
      "has-duplicate": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "exportClicked": function($event) {
        return _vm.exportTryout()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = $event.value;
        _vm.tableKey = $event.key.value;
        _vm.doSearch();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-764bd74c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class_report/components/LiveClassReport.vue
// module id = 1860
// module chunks = 1